import React, { useState } from 'react'
import { ColumnsType } from 'antd/lib/table'
import { useRequest } from 'ahooks'
import $msg from '@/utils/message'
import { getMemberConsumeRecords } from '../../api'
import { formatAmount, formatDateTime, getPaymentText, getShopName, RECORD_PAGE_SIZE } from './record-utils'
import MemberRecordTable from './record-table'

interface Props {
    memberId: number
}

const orderTypeMap: { [key: number]: string } = {
    [-1]: '收银台订单',
    0: '接龙订单',
    1: '商城订单',
    2: '砍价订单',
    3: '拼团订单',
    4: '盲盒订单',
}

const SaleRecord: React.FC<Props> = props => {
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(RECORD_PAGE_SIZE)
    const req = useRequest(() => getMemberConsumeRecords({ member_id: props.memberId, page, limit: pageSize }), {
        refreshDeps: [props.memberId, page, pageSize],
        onError: e => $msg('error', e.message || '获取消费记录失败'),
    })
    const columns: ColumnsType<any> = [
        { title: '时间', dataIndex: 'create_time', width: 176, render: formatDateTime },
        { title: '订单号', dataIndex: 'order_no', width: 186, render: value => value || '-' },
        { title: '订单类型', dataIndex: 'order_type', width: 100, render: value => orderTypeMap[value] || '-' },
        { title: '店铺', dataIndex: 'shop', width: 110, render: getShopName },
        { title: '商品总价', dataIndex: 'subtotal', width: 100, render: formatAmount },
        { title: '支付金额', dataIndex: 'actual_payment', width: 100, render: formatAmount },
        { title: '支付方式', dataIndex: 'payments', width: 115, render: getPaymentText },
    ]

    return (
        <MemberRecordTable
            rowKey={(record, index) => record.order_no || index}
            loading={req.loading}
            columns={columns}
            dataSource={req.data?.order_list || []}
            page={page}
            pageSize={pageSize}
            pagination={req.data?.pagination}
            onPageChange={setPage}
            onPageSizeChange={(nextPage, nextSize) => {
                setPage(nextPage)
                setPageSize(nextSize)
            }}
        />
    )
}

export default SaleRecord
